import React, { useEffect, useState } from "react";
import { alertV2 } from "../../api";
import { parserAPI } from "../../utils/parser";
import { Card, CardBody, CardHeader } from "../card/card";
import { DateRange } from "../DateRange";
import { format, subMonths, startOfDay, endOfDay } from "date-fns";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const MachineHistory = ({ machine }) => {
  const navigate = useNavigate();
  const [events, setSetEvents] = useState([]);
  const [date, setDate] = useState({
    startDate: startOfDay(subMonths(new Date(), 1)),
    endDate: endOfDay(new Date()),
  });

  const handleChangeDate = (startDate, endDate) => {
    setDate({
      startDate,
      endDate,
    });
  };

  async function getAlerts() {
    let allEvents = [];
    try {
      const payload = {
        start_date: date.startDate,
        end_date: date.endDate,
        machine_id: machine.id,
      };
      const res = await alertV2.list(payload);
      const alerts = await parserAPI(res);

      for (const alert of alerts) {
        allEvents.push({
          type: "alert",
          no: alert.id,
          status: alert.alert_status,
          dateTime: alert.max_date,
          prediction: alert.prediction_values,
        });
      }

      allEvents = allEvents.sort((a, b) => (a.dateTime > b.dateTime ? -1 : 1));
      setSetEvents(allEvents);
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  useEffect(() => {
    getAlerts();
  }, [machine, date]);

  return (
    <>
      <div style={{ width: "30%", marginLeft: "auto" }}>
        <DateRange
          onChange={handleChangeDate}
          startDate={date.startDate}
          endDate={date.endDate}
        />
      </div>
      {events.map((e, i) => {
        return (
          <Card
            style={{ cursor: "pointer" }}
            key={i}
            className="border-theme mb-3 mt-3"
            onClick={() => {
              navigate(`/alarm/detail/${e.no}`);
            }}
          >
            <CardHeader className="border-theme fw-bold small text-theme d-flex">
              <div className="flex-1">Alarm #{e.no}</div>
              <div>{format(new Date(e.dateTime), "dd MMMM yyyy | HH:mm ")}</div>
            </CardHeader>
            <CardBody>
              Status : {e.status} <br />
              Suspected Issue <br />
              <ul>
                {e.prediction &&
                  Object.keys(e.prediction).map((k, i) => {
                    return <li key={i}>{k}</li>;
                  })}
              </ul>
            </CardBody>
          </Card>
        );
      })}
    </>
  );
};
